import filterStyles from './StaffWalletDateFilters.module.css';

const PRESET_OPTIONS = [
  { label: '1 Day', value: '1d' },
  { label: '3 Days', value: '3d' },
  { label: '7 Days', value: '7d' },
  { label: 'Custom', value: 'custom' },
];

const StaffWalletDateFilters = ({
  activePreset,
  fromDate,
  toDate,
  onPresetChange,
  onFromDateChange,
  onToDateChange,
  onApplyCustom,
  onClear,
  hasActiveFilters,
  shiftSummary,
}) => {
  return (
    <div className={filterStyles.filtersWrapper}>
      <div className={filterStyles.filtersLayout}>
        <div className={filterStyles.filtersColumn}>
          <p className={filterStyles.filterLabel}>Filter by transaction date</p>
          <div className={filterStyles.presetRow}>
            {PRESET_OPTIONS.map(option => (
              <button
                key={option.value}
                type="button"
                className={`${filterStyles.presetButton} ${
                  activePreset === option.value ? filterStyles.presetButtonActive : ''
                }`}
                onClick={() => onPresetChange(option.value)}
              >
                {option.label}
              </button>
            ))}
            <button
              type="button"
              className={filterStyles.clearButton}
              onClick={onClear}
              disabled={!hasActiveFilters}
            >
              Clear
            </button>
          </div>

          {activePreset === 'custom' && (
            <div className={filterStyles.dateFilterRow}>
              <div className={filterStyles.dateField}>
                <label htmlFor="staff-wallet-from-date">From</label>
                <input
                  id="staff-wallet-from-date"
                  type="date"
                  value={fromDate}
                  onChange={e => onFromDateChange(e.target.value)}
                />
              </div>
              <div className={filterStyles.dateField}>
                <label htmlFor="staff-wallet-to-date">To</label>
                <input
                  id="staff-wallet-to-date"
                  type="date"
                  value={toDate}
                  onChange={e => onToDateChange(e.target.value)}
                  min={fromDate || undefined}
                />
              </div>
              <button
                type="button"
                className={filterStyles.applyButton}
                onClick={onApplyCustom}
                disabled={!fromDate || !toDate}
              >
                Apply
              </button>
            </div>
          )}
        </div>

        {shiftSummary && (
          <div className={filterStyles.shiftSummaryColumn}>
            <div className={filterStyles.shiftSummaryCard}>
              <p className={filterStyles.shiftSummaryTitle}>{shiftSummary.title}</p>
              <div className={filterStyles.shiftSummaryStats}>
                <div className={filterStyles.shiftStat}>
                  <p className={filterStyles.shiftStatLabel}>Total Shifts</p>
                  <p className={filterStyles.shiftStatValue}>{shiftSummary.totalShifts}</p>
                </div>
                <div className={filterStyles.shiftStat}>
                  <p className={filterStyles.shiftStatLabel}>Shift Amount</p>
                  <p className={filterStyles.shiftStatValue}>{shiftSummary.totalShiftAmount}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffWalletDateFilters;
